import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CloudServiceIntroFilm } from "@/components/sections/CloudServiceIntroFilm";
import { DealAlertTeaser } from "@/components/sections/DealAlertTeaser";
import { ProjectWall } from "@/components/sections/ProjectWall";
import { Industries } from "@/components/sections/Industries";
import { Process } from "@/components/sections/Process";
import { ContactSection } from "@/components/sections/ContactSection";
import { ScrollTrigger } from "@/hooks/useSmoothScroll";

export default function Home() {
  useEffect(() => {
    // Recalculate trigger positions once media has settled
    const id = setTimeout(() => ScrollTrigger.refresh(), 600);
    return () => clearTimeout(id);
  }, []);

  return (
    <div className="relative bg-[#05070d] min-h-screen">
      <Navbar />
      <main>
        <CloudServiceIntroFilm />
        <DealAlertTeaser />
        <ProjectWall />
        <Industries />
        <Process />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
